import filter from 'lodash/filter';
import head from 'lodash/head';
import size from 'lodash/size';
import find from 'lodash/find';
import templateUrl from './editor-image-upload-modal.html';

const STATUS = {
    ADD: 0,
    DELETE: 2,
    STATIC: -1
};

export const editorImageUploadModalComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl,

    controller: class EditorImageUploadModalComponent {
        constructor(ImageUploadService, ModalService, ApiService, toastr) {
            'ngInject';

            this.imageUploadService = ImageUploadService;
            this.modalService = ModalService;
            this.apiService = ApiService;
            this.toastr = toastr;
        }

        $onInit() {
            this.contentId = this.resolve.details.data.id;
            this.disableButtons = true;
            this.isBrowseDisabled = false;
            this.selectedImage = "";
            this.selectedImageUuid = "";
            this.images = this._getImages();
            this.tabOptions = [{
                id: 1,
                name: 'upload image',
                isSelected: true
            },{
                id: 2,
                name: 'image library',
                isSelected: false
            }];
            this.isEditOptionEnabled = false;
            this.showUploadedImage = false;
            this.showLoader = false;
            this.selectedTab = head(filter(this.tabOptions, (tabOption) => tabOption.isSelected));
            this.totalNumberOfImages = this._getTotalNumberOfImages();
            this.deletedImages = []; 
        }

        onChangeTab(tab) {
            const previousSelectedTab = head(filter(this.tabOptions, (tabOption) => tabOption.isSelected)); 
            this.selectedTab = head(filter(this.tabOptions, ({id}) => id === tab.id));
            previousSelectedTab.isSelected = false;
            this.selectedTab.isSelected = true;
            this.selectedImageUuid = "";
            this.disableButtons = true;
            this.isEditOptionEnabled = false;
            this.showUploadedImage = false;
        }

        onChangeEdit() {
            this.disableButtons = true;
            this.isEditOptionEnabled = !this.isEditOptionEnabled;
            this.images = this._getImages();
            this.deletedImages = [];
        }

        // on Image upload
        onChangeFile() {
            this.isBrowseDisabled = true;
            const pattern = /^image/g;
            const isImage = pattern.test(this.selectedImage.type);
            if (this.selectedImage && isImage) {
                _upload.call(this, this.selectedImage);
            } else {  
                this.toastr.error("Invalid image file");          
            }

            function _upload(image) {
                this.showLoader = true;

                this.imageUploadService.upload({
                    image: image,
                    name: this.selectedImage.name,
                    container: this.pageName
                })
                .then(({data:{data}}) => {
                    this.showLoader = false;
                    const {uuid} = data;
                    this.isBrowseDisabled = false;
                    this.disableButtons = false;
                    this.showUploadedImage = true;
                    this.selectedImageUuid = uuid;
                    this.images.unshift({uuid, status: STATUS.ADD});
                    this.totalNumberOfImages = this._getTotalNumberOfImages();
                })
                .then(_ => {
                    this.images = this._setImages();
                    this.resolve.details.getAllUpdatedContentImages(this.images)
                })
                .then(_ => this.onSubmit())
                .catch((err) => {
                    this.toastr.error("Image upload failed");
                });
            }
        }

        //on image select
        onSelectImage(selectedUuid) {
            if(!this.isEditOptionEnabled) {
                this.selectedImageUuid = selectedUuid;
                this.disableButtons = false;
            } else {
                this._setDeletedImages(selectedUuid);
                this.disableButtons = size(this.deletedImages) > 0 ? false : true;
            }
        }

        //on Image delete
        onDeleteImage() {
            this._setImageStatusToDeleted();
            this.disableButtons = true;
            this.showUploadedImage = false;
            this.images = this._setImages();
            this.resolve.details.getAllUpdatedContentImages(this.images);
            this.resolve.details.getDeletedImageUuids(this.deletedImages);
            this.selectedImageUuid = "";
            this.close();
        }

        getImageSrcPath(image) {
            return this.apiService.getResourceUrl(`files/images/${image}`)
        }

        onCancel() {
            this.selectedImageUuid = "";
            this.disableButtons = true;
            this.isEditOptionEnabled ? this.onChangeEdit() : this.close();
        }

        onSubmit() {
            this.resolve.details.getSelectedImage(this.selectedImageUuid);
            this.close();
        }

        _getTotalNumberOfImages() {
            return size(filter(this.images, ({status}) => status !== STATUS.DELETE));
        }

        _setDeletedImages(selectedUuid) {
            const selectedImage = find(this.images, ({uuid}) => uuid === selectedUuid);
            selectedImage.isSelected = !selectedImage.isSelected;
            selectedImage.isDeleted = selectedImage.isSelected;
            this.deletedImages = this._getDeletedImages();
        }

        _getDeletedImages() {
            return filter(this.images,({isDeleted}) => isDeleted);
        }

        _setImageStatusToDeleted() {
            this.images = this.images.map(image => {
                if(image.isDeleted && image.status !== STATUS.ADD) {
                    image.status = STATUS.DELETE;
                }
                return image;
            });
            this.images = filter(this.images,({isDeleted, status}) => status !== STATUS.ADD);
        }

        _getImages() {
            return this.resolve.details.data.images.map(({uuid, status})=> ({uuid,status,isSelected:false,isDeleted:false}));
        }

        _setImages() {
            return this.images.map(({uuid,status}) => ({uuid,status}))
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/editor/editor-image-upload-modal/editor-image-upload-modal.component.js